@if (loadingState() === 'loading') {
  <p class="m-0 text-sm text-secondary">Loading Instagram posts…</p>
} @else if (loadingState() === 'error') {
  <p class="m-0 text-sm text-red-600" role="alert">Failed to load Instagram posts.</p>
} @else if ((latestPosts() ?? []).length === 0) {
  <p class="m-0 text-sm text-secondary">No recent Instagram posts found.</p>
} @else {
  <ul class="m-0 grid list-none grid-cols-2 gap-3 p-0 sm:grid-cols-3">
    @for (post of latestPosts() ?? []; track post.post_id ?? post.title) {
      <li>
        <button
          type="button"
          class="w-full cursor-pointer text-left"
          (click)="selectPost(post)">
          <div class="overflow-hidden rounded-lg bg-zinc-100 dark:bg-zinc-800">
            @if (post.thumbnail_url) {
              <img
                [src]="post.thumbnail_url"
                [alt]="post.title || 'Instagram post'"
                class="aspect-[10/7] w-full object-cover" />
            }
          </div>
          <p class="m-0 mt-2 truncate text-sm font-medium text-primary">{{ post.title }}</p>
          <p class="m-0 text-xs text-secondary">{{ postTimeLabel(post) }}</p>
        </button>
      </li>
    }
  </ul>
}
